<template>
  <div class="media checkout-login">
    <!-- <div class="icon-main">
      <div class="icon-round">
        <svg width="25" height="25" fill="none">
          <use xlink:href="#user" />
        </svg>
      </div>
    </div> -->
    <div class="media-body">
      <div
        class="delivery-timeline mobile-dinein"
        v-if="isFloorTableAvailable.table_id"
      >
        <div class="media">
          <div class="icon-main d-none d-lg-block">
            <div class="icon-round">
              <svg width="25" height="25" fill="none">
                <use xlink:href="#dineIn" />
              </svg>
            </div>
          </div>
          <div class="media-body media-body-ai">
            <div class="timeline-card">
              <div class="delivery-content saved-payment">
                <p v-if="dineinArea(isFloorTableAvailable.floor_id)">
                  {{ _T('Area') }}:
                  <b class="text-capitalize">
                    {{ dineinArea(isFloorTableAvailable.floor_id).name }}
                  </b>
                </p>
                <p v-if="dineinTableDetails">
                  {{ _T('Table number') }}:
                  <b>
                    <span :class="'shape ' + dineinTableDetails.table_shape">
                      {{ dineinTableDetails.number }}
                    </span>
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="timeline-card" v-else>
        <h4>
          {{
            _T(
              `${
                guest_checkout
                  ? 'Checkout as a guest'
                  : 'Checkout as returning user'
              }`
            )
          }}
        </h4>
        <checkout-as-guest-user
          v-if="guest_checkout"
          ref="guest_checkout_form"
        />
        <checkout-as-registered-user v-else />
        <div class="divider"></div>
        <div class="auth-bottom pt-0 mobile-signup">
          <div class="signupnow d-flex align-items-baseline w-100">
            <template v-if="guest_checkout">
              <div
                class="d-flex flex-wrap align-items-baseline justify-content-between w-100"
              >
                <div
                  class="d-flex flex-wrap align-items-baseline justify-content-between"
                >
                  <h6 class="mr-2">{{ _T('Want to become a member?') }}</h6>
                  <a
                    href="javascript:void(0)"
                    @click="
                      guestCheckout(false)
                      $bvModal.show('signup')
                    "
                  >
                    {{ _T('Sign Up') }}
                  </a>
                </div>
                <div
                  class="d-flex flex-wrap align-items-baseline justify-content-between"
                >
                  <h6>{{ _T('Already a member?') }}</h6>
                  <a
                    class="pl-1"
                    href="javascript:void(0)"
                    @click="guestCheckout(false)"
                  >
                    {{ _T('Login') }}
                  </a>
                </div>
              </div>
            </template>
            <template v-else>
              <h6 class="mr-2">{{ _T("Don't have an account") }}?</h6>
              <a
                href="javascript:void(0)"
                @click="
                  guestCheckout(false)
                  $bvModal.show('signup')
                "
              >
                {{ _T('Sign Up') }}
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CheckoutAsRegisteredUser from './Checkout/CheckoutAsRegisteredUser'
import CheckoutAsGuestUser from './Checkout/CheckoutAsGuestUser.vue'

export default {
  name: 'CheckoutLoginForm',
  computed: {
    ...mapGetters([
      '_T',
      'guest_checkout',
      'isFloorTableAvailable',
      'dineinArea',
      'dineinTable',
    ]),
    dineinTableDetails() {
      if (this.isFloorTableAvailable.table_id) {
        return this.dineinTable(this.isFloorTableAvailable.table_id)
      }
      return undefined
    },
  },
  components: {
    CheckoutAsRegisteredUser,
    CheckoutAsGuestUser,
  },
  methods: {
    guestCheckout(opt) {
      this.$store.commit('SET_GUEST_CHECKOUT', opt)
    },
  },
}
</script>
<style lang="scss" scoped>
.single-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: $px10;
  @media (max-width: 575px) {
    grid-template-columns: 1fr;
    grid-gap: $px10;
  }
}
.mobile-dinein {
  @media (max-width: 575px) {
    padding: 28px 0px 0px;
  }
}
.media {
  &.checkout-login {
    @media (max-width: 575px) {
      margin-top: 0.75rem;
    }
    .icon-main {
      padding: $px4 $px5;
      background-color: $white;
    }
    .icon-round {
      background-color: $white;
      border-radius: 100%;
      width: $px50;
      height: $px50;
      display: flex;
      justify-content: center;
      background-color: $color-primary !important;
      // border: 4px solid lighten( $color-primary, 30%);
      border: $px4 solid $color-primary !important;
      svg {
        width: $px25;
        height: $px40;
      }
    }
    .media-body {
      margin-left: $px16;
      position: relative;
      padding-bottom: $px20;
      @media (max-width: 767px) {
        margin-left: 0 !important;
      }
      .timeline-card {
        padding: calc(
            #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
          )
          calc(#{$px15} + (36 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
        border: $px1 solid $dark-border;
        @media (max-width: 767px) {
          border: 0 !important;
        }
        border-radius: $px4;
      }
      &::before {
        position: absolute;
        content: '';
        height: 100%;
        border-left: $px2 dashed $dark-border;
        top: 0;
        left: -41.5px;
        margin: $px8 0;
        z-index: -1;
      }
      h4 {
        font-weight: 600;
        margin-bottom: calc(
          #{$px12} + (28 - 12) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
      .mobile-signup {
        margin-top: $px24;
        margin-bottom: unset;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .signupnow {
          text-align: left;
          font-weight: bold;
          @media (max-width: 575px) {
            flex-wrap: wrap !important;
          }
        }
        @media (max-width: 575px) {
          h6 {
            font-size: $px12 !important;
          }
        }
      }
    }
    .auth-bottom {
      justify-content: space-between;
    }
  }
}
.body-rtl {
  .signupnow {
    a {
      margin-right: $px10;
    }
  }
  @media (max-width: 767px) {
    .timeline-card {
      text-align: right;
    }
  }
}
</style>
